<template>
  <g>
    <path
      d="M17 1.00024H7C5.9 1.00024 5 1.90024 5 3.00024V21.0002C5 22.1002 5.9 23.0002 7 23.0002H17C18.1 23.0002 19 22.1002 19 21.0002V3.00024C19 1.90024 18.1 1.00024 17 1.00024ZM16 19.0002H8C7.45 19.0002 7 18.5502 7 18.0002V6.00024C7 5.45024 7.45 5.00024 8 5.00024H16C16.55 5.00024 17 5.45024 17 6.00024V18.0002C17 18.5502 16.55 19.0002 16 19.0002Z"
    />
    <path
      d="M15 6.00024H9C8.45 6.00024 8 6.45024 8 7.00024C8 7.55024 8.45 8.00024 9 8.00024H15C15.55 8.00024 16 7.55024 16 7.00024C16 6.45024 15.55 6.00024 15 6.00024Z"
    />
  </g>
</template>
